import { render, staticRenderFns } from "./DashboardCCS.vue?vue&type=template&id=0aa0dba8&"
import script from "./DashboardCCS.vue?vue&type=script&lang=js&"
export * from "./DashboardCCS.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCCS.vue?vue&type=style&index=0&id=0aa0dba8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports